import {
  nFormatter,
  createSeries,
  createSQL,
  seriesHead,
  appendAggregateValues,
  seriesDataItem,
  pickItem,
  resolve,
  createFilter
} from "@/components/charts/common";
import pluralize from 'pluralize';


function createValueFilter(element) {
  const query = element.model;
  return element.filter.replace(/:query/gi, query);
}

function createFullTextIndexFilter(element) {
  const query = element.model.replace(/ /gi, "&");
  return element.filter.replace(/:query/gi, "'" + query.toLowerCase() + "'");
}

function createDateFilter(element) {
  return element.filter.replace(/:query/gi, element.model.replace(/-/gi, ""));
}


function createInFilter(element) {
  let query = "";
  const parts = element.model.split(/,| |\n|\t/);
  if(parts.length) {
    const last = parts.length-1;
    for(let i = 0; i < parts.length; i++) {
      const part = parts[i];
      query += i == last ? "'" + part + "'" : "'" + part + "',";
    }
  }
  return element.filter.replace(/:query/gi, query);
}


 
function createSelectFilter(element) {
  const model = element.model;
  const selected = element.list.find(item => item.value == model);
  if(selected && typeof selected.filter != "undefined" && selected.filter) {
    return selected.filter;
  }
  return null;
}


function appendCondition(condition, newCondition) {
  if(newCondition) {
    return condition ? condition + " AND " + newCondition : newCondition;
  }
  return condition;
}

function createFilterFromForm(formElements) {
  if(typeof formElements == "undefined" || !formElements) {
    return "";
  }
  let condition = "";
  for(let i = 0; i < formElements.length; i++) {
    const element = formElements[i];
    if(typeof element.model != "undefined" && element.model) {
      // const filter = element.filter;
      // const model = element.model;
      const transform = typeof element.transform != "undefined" && element.transform ? element.transform : null;

      

      if(element.type == 'select') {
        condition = appendCondition(condition, createSelectFilter(element));
      } else if(transform == 'query') {
        condition = appendCondition(condition, createFullTextIndexFilter(element));
      } else if(transform == 'date') {
        condition = appendCondition(condition, createDateFilter(element));
      } else if(transform == 'in') {
        condition = appendCondition(condition, createInFilter(element));
      } else {
          condition = appendCondition(condition, createValueFilter(element));
      }
    }
}
  return condition;
}


function createPagination(opts) {
  try {
    let params = {page: 1};
    if(opts.serverSide) {
      if(opts.rowsPerPage) {
        params.rowsPerPage = opts.rowsPerPage;
      }
      if(opts.page) {
        params.page = opts.page;
      }
      if(opts.sortField && opts.sortDirection) {
        params.sortField = opts.sortField;
        params.sortDirection = opts.sortDirection;
      }
      return params;
    }
  } catch(error) {
    console.log('pagination error', error);
  }
  return null;
}
export default async function hydrator(parameters, data, chart) {

  console.log("this table hydrator");

  let options = {};

 

  options.chart = {};
  options.chart.id = chart.id;
  options.dataLabels = {
    enabled: false
  };
  options.colors = ['#C1BEC7', '#FF0814', '#151821', '#857A89', '#F54355'];
  // options.colors = ['#FA8F13', '#EE2C1F', '#6A7785', '#283BD1', '#454E5D'];
  options.colors = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];

  chart.chartData.loading = false;

  chart.loading = false;

  if(typeof chart.chartData.pagination == 'undefined') {
    chart.chartData.pagination = {page: 1, sortField: null, sortDirection: null};
  }

  chart.chartData.pagination.serverSide = resolve("serverSide.value", parameters, false);
  chart.chartData.pagination.rowsPerPage = resolve("rowsPerPage.value", parameters, 20);

  //chart.chartData.loading = true;

  options.yaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      formatter: function(value) {
        if (isNaN(value)) {
          return value;
        }
        return nFormatter(value, 2);
      }
    }
  };

  options.xaxis = {
    labels: {
      show: true,
      offsetX: 0,
      offsetY: 0
    },
    axisBorder: {
      show: true,
      color: '#78909C',
      height: 1,
      width: '100%',
      offsetX: 0,
      offsetY: 0
    },
    axisTicks: {
      show: true,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0
    }
  };

  const gridHeight = chart.grid.h;
  const layoutHeight = chart.grid.layout.rowHeight;
  const realHeight = (layoutHeight * gridHeight);
  data.height = realHeight;

  // console.log("layoutHeight", layoutHeight);
  // console.log("gridHeight", gridHeight);
  // console.log("realHeight", realHeight);
  // console.log("grid", chart.grid);
  /***
    options.legend = {};
    options.legend.show = false;

    options.xaxis = {};
    options.xaxis.labels = {};
    options.xaxis.labels.show = false;

    options.yaxis = {};
    options.yaxis.labels = {};
    options.yaxis.labels.show = false;

  **/

  // data.options = {...options};

  let chartDataSource = parameters.chartDataSource;
  // let customFilter = resolve("customFilter.value", parameters);



  

  let orderBy = resolve("orderBy.value", parameters);


  

  chart.chartData.searchFormDesign = resolve("searchFormDesign.value", parameters);
  const searchFormSchema = resolve("searchFormSchema.value", parameters);


  if(typeof chart.chartData.searchFormSchema == "undefined" || !chart.chartData.searchFormSchema) {

    chart.chartData.displaySearch = false;

    chart.chartData.searchFormClass = "xs3 justify-end";
    chart.chartData.tableClass = "xs12";

    chart.chartData.searchFormSchema = null;
      if(searchFormSchema) {
        try {
          chart.chartData.searchFormSchema = JSON.parse(searchFormSchema);
        } catch(error) {
          chart.chartData.searchFormSchema = null;
        }
      }

      if(chart.chartData.searchFormDesign == 'top'&& chart.chartData.searchFormSchema) {
        chart.chartData.searchFormClass = "xs12";
        chart.chartData.tableClass = "xs12";
        chart.chartData.displaySearch = true;
      } else if(chart.chartData.searchFormDesign == 'left'&& chart.chartData.searchFormSchema) {
        chart.chartData.searchFormClass = "xs3";
        chart.chartData.tableClass = "xs9";
        chart.chartData.displaySearch = true;
      }
  }


  // console.log("chart.chartData.searchFormSchema", chart.chartData.searchFormSchema);

  const formFilter = createFilterFromForm(chart.chartData.searchFormSchema);
  // console.log("formFilter", formFilter);

  let customFilter = appendCondition(createFilter(chart, parameters), formFilter);
  console.log("customFilter", customFilter);

  chart.chartData.autoSelect = resolve("autoSelect.value", parameters);
  chart.chartData.autoRefresh = resolve("autoRefresh.value", parameters);

  let items = parameters.chartDataSource.items;

  

  // for (let i = 0; i < items.length; i++) {
  //   // await items[i].update(true);
  //   console.log("chartDataSource", items[i]);
  // }

  if (!chartDataSource.item.data.length && items.length) {
    chartDataSource.item = items[0];
    chartDataSource.value = items[0].id;
  }
  // console.log("chartDataSource.item.headers", chartDataSource.item.headers);
  chartDataSource.item.headers.forEach(function(t) {
    // console.log(t.text + " : " + t.type.type + " : " + t.type.points);
  });

  //  console.log("chartDataSource.item.fullQuery", chartDataSource.item.fullQuery);


  let query = {};
  let fullQuery = chartDataSource.item.fullQuery;
  let sqlQuery = resolve("sqlQuery.value", parameters);
  if(sqlQuery) {
    console.log('this sqlQuery', sqlQuery);
    fullQuery = sqlQuery;
  }
  query.id = chartDataSource.item.id;


  let _filters = resolve("tree.filters", chart);
  console.log("tree filters", _filters);
  let filters = _filters ? Object.values(_filters) : [];


  let queryParameters = {
    id: chartDataSource.item.id,
    fullQuery: fullQuery,
    filters: filters
  };
  console.log("this query", query);
  let aItem = {};

  aItem.queryParameters = queryParameters;


  //console.log("series size", series.length);
  //  console.log("series data", series);



  // console.log('max', max);

  // chart.chartData.headers = Object.keys(dd.data[0]);
  let headers = [];


  function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  let result = {};

  result.headers = headers;
  result.items = [];

  chart.activeItem = null;
  
  // chart.dataSource = null;

  chart.setPage = function(page) {
    chart.chartData.pagination.page = page;
  }
  chart.setRowsPerPage = function(rowsPerPage) {
    chart.chartData.pagination.rowsPerPage = rowsPerPage;
  }

  chart.setSort = function(field, sortDirection) {
    chart.chartData.pagination.sortField = field;
    chart.chartData.pagination.sortDirection = sortDirection;
  }

  chart.loadActiveItem = async function(save) {
    // return;
    // console.log("loadActiveItem");
    chart.chartData.loading = true;
    chart.loading = true;
    const item = chart.activeItem;

    chart.subHeaders.forEach((item, i) => {
      item.position = i;
    });
    const l = chart.subHeaders.length;
    parameters.selectedColumns.value = JSON.stringify(chart.subHeaders);
    // console.log("parameters.selectedColumns.value", parameters.selectedColumns.value);

    let fields = '';
    let group = '';
    let hasAgg = false;
    for (let i = 0; i < l; i++) {
      const column = chart.subHeaders[i];
      if (column.selected != true) {
        continue;
      }

      let agg = typeof column.aggregate != "undefined" && column.aggregate && typeof column.aggregate.function != "undefined" ? column.aggregate : {function: "field"};
      // console.log("agg", agg);
      // console.log("column", column);
      let agg2 = agg.function.replace("field", column.value);

      if (agg2 != column.value) {
        fields += agg2 + " AS " + column.value + ",";
        group += typeof agg.aggregateFunction != "undefined" && agg.aggregateFunction == true ? "" : agg2 + ",";
        if(typeof agg.aggregateFunction != "undefined" && agg.aggregateFunction == true) {
          hasAgg = true;
        }
      } else {
        fields += column.value + ",";
        group += column.value + ",";
      }
    }

    if (fields.slice("-1") == ",") {
      fields = fields.slice(0, -1);
    }

    if (group.slice("-1") == ",") {
      group = group.slice(0, -1);
    }

    let iFullQuery = item.queryParameters.fullQuery;
    let sql = "SELECT " + fields + " FROM (" + iFullQuery + ") AS _subQuery ";
    // let iSqlQuery = resolve("sqlQuery.value", parameters);
    // if(iSqlQuery) {
    //   console.log('this iSqlQuery', iSqlQuery);
    //   iFullQuery = iSqlQuery;
    //   sql = "SELECT * FROM (" + iFullQuery + ") AS _subQuery ";
    // }

    // let sql = "SELECT " + fields + " FROM (" + iFullQuery + ") AS _subQuery ";
    // console.log('this sql',sql);
    let filters = [...item.queryParameters.filters];
    // console.log('filters', filters);
    // filters.push()
    // console.log('customFilter', customFilter);
    if(customFilter.trim()) {
      sql += "WHERE " + customFilter + " ";
    } else {
      sql += "WHERE 1 = 1 " ;
    }



    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i];
      sql += " AND " + filter.field + "" + filter.operator + "'" + filter.value + "' ";
    }

    sql += group && hasAgg ? "GROUP BY " + group : "";
    const pagination = createPagination(chart.chartData.pagination);

    try {
      if(pagination.sortField && pagination.sortDirection) {
        orderBy = pagination.sortField + ' ' + pagination.sortDirection;
      }

    } catch(error) {

    }

    try {
      if(orderBy.trim()) {
        sql += " ORDER BY " + orderBy;
      }
    } catch(err) {

    }

    // const rowsPerPage

    // console.log("calling sql " + sql);

    try {
      chart.loading = true;
      
      //console.log('pagination pagination', pagination);
      chart.downloadQuery = {...{sql: sql, id: item.queryParameters.id, rowsPerPage: 10000}};
      const queryParams = {...{sql: sql, id: item.queryParameters.id, rowsPerPage: 10000}, ...pagination};
      //console.log('pagination queryParams', queryParams)

      console.log('this queryParams', queryParams);
      chart.dataSource = await chartDataSource.item.request(queryParams);

      chart.response = chart.dataSource;
      // console.log('chart.response', chart.response);
      chart.loading = false;
      if(typeof chart.loadCompleted != 'undefined') {
        chart.loadCompleted();
      }
      
    } catch(err) {
      chart.loading = false;
    }
    console.log("loadActiveItem", save);
    // console.log(sql);
    // console.log(chart.dataSource);
  }
  chart.activeItems = [];
  chart.activeItems2 = [];

  chart.setActiveItem = async function(item) {

    // chart.dataSource = null;
    chart.loading = true;
    chart.activeItem = {...item};
    chart.activeItems = [item];
    setHeaders(parameters.chartDataSource.item.headers);
    chart.loadActiveItem('hydrator');

  }
  function setHeaders(fullHeaders) {
    // chart.subHeaders
    // console.log("1. parameters.selectedColumns.value", parameters.selectedColumns.value);
    let h = [];
    let subHeaders = [...fullHeaders];
    try {
       h = JSON.parse(parameters.selectedColumns.value);
    } catch(err) {

    }
    if(!Array.isArray(h)) {
      h = [];
    }
    //console.log("hello", h);
  //  subHeaders = [...fullHeaders];
    let r = [];

    for(let i = 0; i < subHeaders.length; i++) {
      let item = subHeaders[i];
    // subHeaders.forEach((item, i) => {
      item.menu = false;
      item.aggregate = null;
      item.position = i;
      if (typeof item.selected == "undefined") {
        item.selected = true;
      }

      const found = h.find(function(element) {return element.value == item.value;});

      item.selected = found && typeof found.selected != "undefined" ? found.selected : item.selected;
      item.aggregate = found && typeof found.aggregate != "undefined" ? found.aggregate : item.aggregate;

      if(found && typeof found.position != "undefined" && found.position != item.position) {
        // console.log("item position", item.value + ":" + item.position);
        // console.log("found position", item.value + ":" + found.position);
      }
      item.position = found && typeof found.position != "undefined" ? found.position : item.position;
      // console.log("item 2 position", item.value + ":" + item.position);
      if(found) {

      }

      subHeaders[i] = item;
      r.push({...item});

    }
    r = r.sort(function(a, b){ return a.position-b.position});
    r.forEach(it => {
      if(it.value == "year") {
        // console.log("year item", it);
      }
    })
    chart.subHeaders = [];
    chart.subHeaders = [...r];
    // console.log("sorted position subHeaders", r);
  }

  chart.download = async function() {
    // alert("hey");
    
    let response = await chartDataSource.item.download(chart.downloadQuery);
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', 'Download.csv');
    document.body.appendChild(fileLink);

    fileLink.click();
  };

  chart.setActiveItem(aItem);

  chart.chartData.loading  = false;

  chart.chartData.series = [];
  chart.headers = headers;
  // chart.chartData.series = series;
  chart.chartData.options = {
    chart: {
      enabled: true
    }
  };

  if(typeof  chart.afterLoad != "undefined") {
    chart.afterLoad();
  }
  // console.log("chart.chartData", chart.chartData)

}
